import { LayoutActivityType, ModalsType } from '@Techedge/digitalportal-shared'

export const ActivityTypeModalsMap = {
    [LayoutActivityType.NEWS]: ModalsType.TASK_EXECUTION,
    [LayoutActivityType.TASK]: ModalsType.TASK_EXECUTION,
    [LayoutActivityType.VISIT]: ModalsType.VISIT_EXECUTION,
}
